import cls from "./BlogPostHero.module.css";
import { Breadcrumbs } from "@/components/UI/Breadcrumbs/Breadcrumbs";
import { getBlogPagePath, getHomePagePath } from "@/utils/consts";

interface BlogPostHeroProps {
    title: string;
    breadcrumbTitle?: string;
    date: string;
    dateLabel?: string;
    readTime: number;
    reviewedBy?: string;
    reviewedByJobTitle?: string;
    parentLabel?: string;
    parentHref?: string;
}

export const BlogPostHero = ({
    title,
    breadcrumbTitle,
    date,
    dateLabel = "Posted",
    readTime,
    reviewedBy,
    reviewedByJobTitle,
    parentLabel = "Blog",
    parentHref = getBlogPagePath(),
}: BlogPostHeroProps) => {
    const breadcrumbs = [
        { label: "Home", href: getHomePagePath() },
        { label: parentLabel, href: parentHref },
        { label: breadcrumbTitle ?? title },
    ];

    return (
        <section className={cls.hero}>
            <div className={cls.heroInner}>
                <div className={cls.breadcrumbsContainer}>
                    <Breadcrumbs items={breadcrumbs} className={cls.invert} />
                </div>

                <h1 className={cls.title}>{title}</h1>

                <p className={cls.meta}>
                    {dateLabel} {date} <span className={cls.dot}>•</span> {readTime} min read
                    {reviewedBy && (
                        <span>
                            <span className={cls.dot}>•</span> Reviewed by {reviewedBy}, {reviewedByJobTitle}
                        </span>
                    )}
                </p>
            </div>
        </section>
    );
};
